/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Accreditation_HeadingInputs */

const en_welcome_accreditation_heading = /** @type {(inputs: Welcome_Accreditation_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accredited Investor Status`)
};

/**
* | output |
* | --- |
* | "Accredited Investor Status" |
*
* @param {Welcome_Accreditation_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const welcome_accreditation_heading = /** @type {((inputs?: Welcome_Accreditation_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Accreditation_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_accreditation_heading(inputs)
});